import React from 'react';
import ReactDOM from 'react-dom';
import './index.css'; // Optional: CSS-Datei für Styling
import App from './App'; // Dein Haupt-React-Komponenten-Einstiegspunkt
import './index.css'; // globale CSS, in der du html,body,#root definierst

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root') // Bindet die React-App an das <div id="root"> in der index.html
);
